import { render, staticRenderFns } from "./GPFUP.vue?vue&type=template&id=383fedd3&"
import script from "./GPFUP.vue?vue&type=script&lang=ts&"
export * from "./GPFUP.vue?vue&type=script&lang=ts&"
import style0 from "./GPFUP.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports